module.exports = "/_next/static/images/UDJ6-b40596606adebceaa75eafda9294b79d.svg";